// extracted by mini-css-extract-plugin
export default {"iconBackground":"discord-georestrictions-tooltip-module__iconBackground___noP6i","tooltipContent":"discord-georestrictions-tooltip-module__tooltipContent___YMZBI"};